import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetRecoveryFundsByFundraisingId = id => {
  return useQuery({
    staleTime: 1000 * 60 * 60, // 1 hour,
    queryKey: [QUERY_KEYS.loan.recovery_funds_by_fundraising_id, id],
    queryFn: () =>
      loanService.recoveryFundsByFundraisingId(id).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
